import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 402 && window.location.pathname !== "/pricing") {
      window.location.href = "/pricing?expired=1";
    }
    return Promise.reject(error);
  }
);

export default api;
